<template>
  <section class="publications py-5">
    <div class="container">
        <!-- <h4 class="section-subtitle text-center mb-4">
            Publications
        </h4> -->

        <div class="row g-4">
            <div
            class="col-md-6 col-lg-4"
            v-for="(book, i) in publications"
            :key="i"
            >
            <div class="book-card h-100 d-flex">
  

                <div class="book-image-wrapper">
                    <img
                        :src="book.urlImage ? getUrlApiForFiles(book.urlImage) : defaultPhoto"
                        alt="Couverture du livre"
                        class="book-image clickable"
                        @click="openImage(book.urlImage)"
                    />

                </div>

                <!-- TEXTE À DROITE -->
                <div class="book-content">
                    <h5 class="book-title">{{ book.titre }}</h5>

                    <p class="book-author">
                    <strong>Auteur(s) :</strong> {{ book.auteur }}
                    </p>

                    <p class="book-meta">
                    <strong>Maison d'édition :</strong> {{ book.editeur }}
                    </p>

                    <p class="book-meta">
                    <strong>Année :</strong> {{ book.annepublication }}
                    </p>
                </div>

            </div>

            </div>
        </div>
        <!-- <div class="row justify-content-center g-4 mt-3">
            <div
            class="col-6 col-md-4 col-lg-3"
            v-for="(img, i) in bookImages"
            :key="i"
            >
            <img
                :src="img"
                alt="Couverture de livre"
                class="standalone-book-image"
            />
            </div>
        </div> -->
    </div>
    <!-- MODALE IMAGE -->
    <div v-if="showImageModal" class="image-modal" @click.self="closeImage">
    <div class="image-modal-content">
        <button class="close-btn" @click="closeImage">×</button>

        <img
        :src="activeImage"
        alt="Image agrandie"
        class="image-modal-img"
        />
    </div>
    </div>

    <div class="mt-4">
        <PaginationComponent
          :page="page"
          :totalPages="totalPages"
          :totalElements="totalElements"
          :limit="limit"
          @paginate="handlePaginate"
        />
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from "vue";
import ApiService from "@/services/ApiService";
import { getUrlApiForFiles, error,format_Date } from "@/utils/utils";
import PaginationComponent from '@/components/Utilities/Pagination.vue';
import debounce from "lodash/debounce";

interface Publication {
  id: number
    titre: string
    auteur: string
    editeur:string,
    categoriepublication: string
    urlImage: string
    lieu: string,
    annepublication:number,
    contenu: string
}


export default defineComponent({
  name: "LesPublications",
  components: { PaginationComponent },

  setup() {
    const publications = ref<Publication[]>([]);
    const defaultPhoto = "/livres.jpg";

    const page = ref(1);
    const limit = ref(12);
    const totalPages = ref(0);
    const totalElements = ref(0);
    const searchTerm = ref('');
   
    const showImageModal = ref(false)
    const activeImage = ref('')

    const openImage = (filename?: string) => {
    if (!filename) return
    activeImage.value = getUrlApiForFiles(filename)
    showImageModal.value = true
    }

    const closeImage = () => {
    showImageModal.value = false
    activeImage.value = ''
    }

    // Pagination handler
    const handlePaginate = ({ page_: newPage, limit_: newLimit }) => {
      page.value = newPage;
      limit.value = newLimit;
      getTreeDisciples(newPage, newLimit);
    };
    function rechercher(){
      getTreeDisciples(page.value, limit.value, searchTerm.value );
    }
    // Chargement des étudiants
    const getTreeDisciples = async (pageNum = 1, limi = 12, searchTerm='') => {
      try {
        const { data } = await ApiService.get(
          `/publications/categorie/Mémoire?page=${pageNum}&limit=${limi}&mot=${searchTerm}&`
        );
        publications.value = data.data.data;
        console.log("gggg",publications.value)
        totalPages.value = data.data.totalPages;
        limit.value = data.data.limit;
        totalElements.value = data.data.totalElements;

      } catch (error) {
        console.error("Erreur chargement disciples :", error);
      }
    };
    function getImageUrl(filename?: string) : string {
      if (!filename) return ''
      return `${ApiService.vueInstance.axios.defaults.baseURL?.split("api")[0]}uploads/Users/${filename}`; }

    // Chargement initial
    onMounted(() => {
      getTreeDisciples(page.value, limit.value);
    });

    return {
        openImage,
        closeImage,
        showImageModal,
        activeImage,
        publications,
        defaultPhoto,
        page,
        limit,
        totalPages,
        totalElements,
        handlePaginate,
        rechercher,
        searchTerm,
        getImageUrl,
        getUrlApiForFiles
    };
  },
});
</script>

<style scoped>
.publications {
  background: #f8f9fa;
}

.section-subtitle {
  color: #0b1b3f;
  font-weight: 700;
}

.book-card {
  background: #fff;
  padding: 22px;
  border-radius: 16px;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.08);
  transition: transform 0.3s ease;
}

.book-card:hover {
  transform: translateY(-6px);
}

.book-title {
  color: #0b1b3f;
  font-weight: 700;
  margin-bottom: 10px;
  font-size: 1rem;
}

.book-author {
  color: #333;
  font-size: 0.95rem;
}

.book-meta {
  color: #555;
  font-size: 0.9rem;
  margin-bottom: 4px;
}
.books-images {
  background: #fff;
  padding: 40px 20px;
  border-radius: 18px;
  box-shadow: 0 6px 20px rgba(0,0,0,0.08);
  
}

.standalone-book-image {
  width: 100%;
  height: 400px; 
  object-fit: cover;
  border-radius: 16px;
  box-shadow: 0 10px 25px rgba(0,0,0,0.2);
  transition: transform 0.3s ease;
}


.standalone-book-image:hover {
  transform: translateY(-8px) scale(1.03);
}
.book-card {
  display: flex;
  gap: 16px;
  align-items: flex-start;
}

/* IMAGE */
.book-image-wrapper {
  flex: 0 0 110px;
}

.book-image {
  width: 110px;
  height: 150px;
  object-fit: cover;
  border-radius: 12px;
  box-shadow: 0 6px 15px rgba(0,0,0,0.15);
}

/* TEXTE */
.book-content {
  flex: 1;
}
/* CURSOR */
.clickable {
  cursor: zoom-in;
}

/* MODALE */
.image-modal {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.8);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* CONTENU */
.image-modal-content {
  position: relative;
  max-width: 90%;
  max-height: 90%;
}

/* IMAGE */
.image-modal-img {
  max-width: 100%;
  max-height: 90vh;
  border-radius: 14px;
  box-shadow: 0 20px 50px rgba(0,0,0,0.6);
}

/* BOUTON FERMER */
.close-btn {
  position: absolute;
  top: -14px;
  right: -14px;
  background: #fff;
  border: none;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  font-size: 22px;
  cursor: pointer;
  box-shadow: 0 6px 15px rgba(0,0,0,0.3);
}

</style>
